import { TableHeadersType } from "../tableHeadersType";

export const BATCH_MANAGEMENT_HEADER: TableHeadersType[] = [
  {
    label: "Batch ID",
    value: "batch_number",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Manufacturing Date",
    value: "manufacturing_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Expiry Date",
    value: "expiry_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "updated_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Status",
    value: "status",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];

